export default __webpack_public_path__ + "static/media/logo.17aa1c12.png";